import { FC, memo } from 'react';
import cn from 'bem-cn';
import { FeedFormula } from '@ai-platform/utils';
import { Link, Stack } from '../../components/UI';
import { usePromptFeedColumns } from '../HomePage/HomePage.hooks';
import { Feed, useInfiniteFeed } from '../../components/Feed';

import aliceLogo from './assets/alice-logo.svg';
import pixels from './assets/pixels.png';
import './PromoResearchPage.scss';

const b = cn('promo-research-page');

export const PromoResearchPage: FC = memo(() => {
    const columns = usePromptFeedColumns(true);

    const {
        prompts,
        loading: isLoading,
        hasMore,
    } = useInfiniteFeed({
        threshold: 600,
        category: 'research',
        formulaName: FeedFormula.PromoResearch,
    });

    const aliceURL = 'https://alice.yandex.ru?from=prompthub&utm_source=prompthub&utm_medium=promo-research';

    return (
        <div className={b()}>
            <div className={b('header')}>
                <div className={b('logo')}>
                    <Link external to={aliceURL}>
                        <img src={aliceLogo} className={b('logo', 'image')} alt="Alice AI" />
                    </Link>
                </div>

                <Stack className={b('header', 'content')}>
                    <img className={b('header', 'content', 'image')} src={pixels} alt="" />
                    <Stack className={b('header', 'content', 'text-block')}>
                        <h1 className={b('title')}>Агент &laquo;Исследовать&raquo; от&nbsp;Алисы&nbsp;AI</h1>
                        <p className={b('description')}>
                            С&nbsp;помощью агента &laquo;Исследовать&raquo; вы&nbsp;сможете быстро понять, как решить
                            даже самую сложную задачу. Он&nbsp;проанализирует сотни источников и&nbsp;сформирует отчёт
                            с&nbsp;фактами и&nbsp;расчётами за&nbsp;считанные минуты.
                        </p>
                        <p className={b('legal')}>
                            Условия использования:{' '}
                            <Link external underlined to="https://yandex.ru/legal/alice_chat/ru/">
                                https://yandex.ru/legal/alice_chat/ru/
                            </Link>
                            . До&nbsp;3&nbsp;исследований в&nbsp;месяц без подписки Алиса Плюс
                        </p>
                    </Stack>
                </Stack>
            </div>
            <div className={b('content')}>
                <h3 className={b('feed-title')}>Примеры задач &mdash; попробуйте прямо сейчас</h3>
                <Feed
                    containerClassName={b('feed')}
                    prompts={prompts}
                    courses={[]}
                    challenges={[]}
                    columns={Math.min(columns, 4)}
                    isLoading={isLoading}
                    hasMore={hasMore}
                    needMarkPromptsAsViewed={false}
                    isHomePage
                    cardClickOpenAliceChat
                />
            </div>
        </div>
    );
});
